@use '@/sass/variables';

@keyframes progressBar {
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}

.progressBarContainer {
  height: 5px;
  position: relative;
  background: #f3efe6;
  overflow: hidden;

  span {
    display: block;
    height: 100%;

    .progressBar {
      background-color: variables.$dark-blue;
      animation-name: progressBar;
      animation-timing-function: ease-in-out;
      animation-fill-mode: both;
    }

    .progressBar.gold {
      background-color: variables.$gold;
    }

    .progressBar.darkGreen {
      background-color: variables.$dark-green;
    }
  }
}
